import Vue from 'vue'
import Vuelidate from 'vuelidate'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import PortalVue from 'portal-vue'

Vue.use(Vuelidate)
Vue.use(ElementUI, { locale })
Vue.use(PortalVue)
